import * as React from 'react';
import CustomerIcon from 'lib/CustomerIcon';
import { PageHeader } from '@salesforce/design-system-react';

type RecordDetail = {
	label: string,
	content: string | JSX.Element,
	truncate?: boolean
};

interface RecordHomeProps {
	buttons: React.ReactNode;
	details: RecordDetail[];
	page: string | JSX.Element;
	section?: string | JSX.Element;
	title: string | JSX.Element;
}

const RecordHome: React.SFC<RecordHomeProps> = ({ buttons, details, page, section, title }) => {
	return (
		<PageHeader
			className="overview-table"
			details={details}
			icon={<CustomerIcon />}
			label={<span>{section ? section : 'Single Customer View'} > {page}</span>}
			contentRight={buttons}
			title={title}
			variant="recordHome"
		/>
	);
};

export default RecordHome;


// WEBPACK FOOTER //
// ./src/lib/RecordHome/index.tsx